import { render, staticRenderFns } from "./AddNewCrmTask.vue?vue&type=template&id=255dfdba"
import script from "./AddNewCrmTask.vue?vue&type=script&lang=js"
export * from "./AddNewCrmTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports